export const autoScrollCalendarStorageKey = 'auto-scroll-calendar';
export const assignmentSortStorageKey = 'assignment-sorting';

export enum AssignmentSorting {
  DRIVER_NAME = 'driver_name',
  END_TIME = 'end_time',
  START_TIME = 'start_time',
  VEHICLE_NAME = 'vehicle_name',
}
